import React, { useState } from 'react';
import { ReactComponent as NewProject } from 'images/icons/NewProjectIcons/CreateNewProject.svg';
import { ReactComponent as Cheveron } from 'images/ContentShowcase/Cheveron.svg';
import mixpanel from 'lib/Analytics/Mixpanel';
import hasAccess from 'components/Helpers/brandHasAccess';
import { useSession } from 'components/Session';
import AddCreditsModal from 'components/Products/AddCreditsModal/AddCreditsModal';
import AlternateSignUpDialog from 'components/Common/AlternateSignUpDialog';
import { toNewCampaign } from 'constants/routes';
import { isAlternateCampaignDialogEnabled } from 'constants/alternateSignUp';

const TypeSectionTitle = ({ option, titleClick, isOpen }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [alternateDialogOpen, setAlternateDialogOpen] = useState(false);
  const show = hasAccess();
  const { brand } = useSession(false);

  function proceedToNewCampaign() {
    const credits = brand ? brand.credits || brand.standardCredits : 0;
    if (brand && brand.firstCampaign && credits === 0) {
      setModalOpen(true);
      return;
    }
    if (mixpanel) {
      mixpanel.track('Brand Starts Campaign', { type: option });
    }
    toNewCampaign(option);
  }

  function trackRouting() {
    if (option === 'social') {
      return;
    }
    if (isAlternateCampaignDialogEnabled) {
      setAlternateDialogOpen(true);
      return;
    }
    proceedToNewCampaign();
  }

  const closeModal = () => setModalOpen(false);
  const closeAlternateDialog = () => setAlternateDialogOpen(false);
  const iconClass = isOpen ? 'cheveron-icon open' : 'cheveron-icon';

  return (
    <>
      <AddCreditsModal show={modalOpen} onClose={closeModal} />
      {isAlternateCampaignDialogEnabled && (
        <AlternateSignUpDialog open={alternateDialogOpen} onClose={closeAlternateDialog} />
      )}
      <div style={{ padding: '0 8px 10px 15px' }}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className="menu-title"
            role="presentation"
            style={{
              color: 'white',
              textTransform: 'capitalize',
              display: 'auto',
            }}
          >
            {option} Projects
          </div>
          <div
            className="icons"
            style={{
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {show && (
              <button
                className="u-button-reset new-project"
                onClick={trackRouting}
                style={{ display: option === 'social' ? 'none' : 'auto' }}
                title="Create new project"
              >
                <NewProject className="new-project-icon" />
              </button>
            )}
            <button className="u-button-reset toggle-projects-btn" onClick={() => titleClick()}>
              <Cheveron className={iconClass} />
            </button>
          </div>
        </span>
      </div>
    </>
  );
};

export default TypeSectionTitle;
